import { useContext } from "react";
import ModalAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoT/ModalAutoT";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";

const EfectivoMP = () => {
  //#region --------- context ---------------
  const { textosAutoCheckinState, pasoDispatch, puntoControlDispatch } =
    useContext(AutocheckContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------
  const textos = textosAutoCheckinState.textosAutoCheckin.data.pagoEfectivo;
  const nombre = textos.nombre;
  const descripcion = textos.descripcion;
  //#endregion --------- constants ---------------
  //#region  ----------- funciones ---------------
  const handleClickOne = () => {
    setPaso("AbonarMP")(pasoDispatch);
  };
  const handleClickTwo = () => {
    const idTipoPuntoControl = 7;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };
  //#endregion --------- funciones ---------------

  return (
    <ModalAutoT
      title={nombre}
      desc={descripcion}
      textBtnOne={"Volver a MP"}
      textBtnTwo={"Continuar"}
      handleChange={{ btnOne: handleClickOne, btnTwo: handleClickTwo }}
    />
  );
};

export default EfectivoMP;
